import { connect } from 'react-redux';
import { deleteDeviation } from '../../../redux/deviations/actionCreators';
import { deleteTier } from '../../../Tier/redux/creator/actions';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
const mapDispatchToProps = (dispatch)=>({
        onClick: (payload)=>{
            if (getDeviationType(payload.deviation) === DeviationTypes.TIER) {
                dispatch(deleteTier(payload.deviation));
            } else {
                dispatch(deleteDeviation(payload));
            }
        }
    });
export default connect(null, mapDispatchToProps);
